import React, { useState } from "react";
import { ChevronRight, Dot } from "lucide-react";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "../ui/collapsible";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from "../ui/sidebar";
import { Link } from "react-router-dom";
import { YoutubeOutlined } from "@ant-design/icons";
import { UserGuideDrawer } from "../UserGuideModal/UserGuideDrawer";

interface SidebarFeature {
  id: string;
  label: string;
  icon: string;
  navigation: string;
  is_show_navigation: number;
  is_locked: number;
  feature_yt_url?: string;
}

export function NavMain({
  items,
  navigationPath,
}: {
  items: any;
  navigationPath: any;
}) {
  const [guideVisible, setGuideVisible] = useState(false);
  const [selectedFeature, setSelectedFeature] = useState<SidebarFeature | null>(null);

  const handleOpenGuide = (feature: SidebarFeature) => {
    setSelectedFeature(feature);
    setGuideVisible(true);
  };

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Navigations</SidebarGroupLabel>
      <SidebarMenu>
        {items?.map((item: any, index: number) => (
          <Collapsible
            key={item?.category?.name}
            asChild
            defaultOpen={index === 0}
            className="group/collapsible"
          >
            <SidebarMenuItem className="!text-sm">
              <CollapsibleTrigger asChild>
                <SidebarMenuButton tooltip={item.category?.name}>
                  {item.category?.icon && (
                    <span className="material-symbols-outlined">
                      {item.category?.icon}
                    </span>
                  )}
                  <span>{item.category?.name}</span>
                  <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                </SidebarMenuButton>
              </CollapsibleTrigger>
              <CollapsibleContent>
                <SidebarMenuSub>
                  {item?.features?.map((feature: SidebarFeature) =>
                    feature?.is_show_navigation == 1 ? (
                      <SidebarMenuSubItem key={feature.id}>
                        <SidebarMenuSubButton asChild>
                          <div className="flex justify-between items-center">
                            <div>
                              {feature?.is_locked == 1 ? (
                                <div className="cursor-not-allowed opacity-50 flex items-center gap-2">
                                  <span className="material-symbols-outlined">
                                    {feature.icon}
                                  </span>
                                  <span className="text-md">
                                    {feature.label}
                                  </span>
                                </div>
                              ) : (
                                <Link
                                  className="flex items-center gap-2 whitespace-nowrap"
                                  to={`../${navigationPath}/${feature.navigation}`}
                                >
                                  <span className="material-symbols-outlined">
                                    {feature.icon}
                                  </span>
                                  <span className="text-md">
                                    {feature.label}
                                  </span>
                                </Link>
                              )}
                            </div>

                            <div>
                              <YoutubeOutlined
                                className="cursor-pointer hover:text-red-500 transition-colors"
                                onClick={() => handleOpenGuide(feature)}
                              />
                            </div>
                          </div>
                        </SidebarMenuSubButton>
                      </SidebarMenuSubItem>
                    ) : null,
                  )}
                </SidebarMenuSub>
              </CollapsibleContent>
            </SidebarMenuItem>
          </Collapsible>
        ))}
      </SidebarMenu>

      {selectedFeature && (
        <UserGuideDrawer
          visible={guideVisible}
          onClose={() => setGuideVisible(false)}
          featureLabel={selectedFeature.label}
          navURL={selectedFeature.navigation}
          youtubeUrl={selectedFeature.feature_yt_url}
        />
      )}
    </SidebarGroup>
  );
}
